import { ref, get } from "firebase/database";
import { database } from "../../../Utils/firebase";
import * as actionType from "../../../context/actions";

const GetAuthUserDataInFirebase = async (state, dispatch, userId) => {
    const USERID = userId ? userId : state?.USERID;

    console.log("userid", USERID);

    if (!USERID) return null;

    try {

        const sharedRef = ref(
            database,
            `invoiceGenerator/users/${USERID}/sharedWith`
        );

        const snapshot = await get(sharedRef);

        if (!snapshot.exists()) {

            dispatch({
                type: actionType.AGENCYMEMBER,
                payload: []
            });

            return { success: true, data: [] };
        }

        const data = snapshot.val();

        // convert object → array for UI
        const usersList = Object.entries(data).map(([uid, value]) => ({
            uid,
            ...value
        }));

        dispatch({
            type: actionType.AGENCYMEMBER,
            payload: usersList
        });

        return {
            success: true,
            data: usersList
        };

    } catch (error) {

        console.error("Firebase Error:", error);

        return {
            success: false,
            message: error.message || "Failed to fetch data"
        };

    }
};

export default GetAuthUserDataInFirebase;